<div class="flex flex-col gap-4">
  <div class="text-center font-roboto-700 text-17">
    {{ "H2H" | translate }}
  </div>

  <app-h2h-tab-bar
    (valueTap)="handleTabChange($event)"
    [away]="getAwayTeamName()"
    [home]="getHomeTeamName()"
  />

  <!--  -->
  @if(fetchStatus().isError && !fetchStatus().isLoading) {
  <app-no-result message="noFoundMatch" />
  }
  <!--  -->
  @if(data().Matches.length === 0 && !fetchStatus().isLoading) {
  <app-no-result message="noFoundMatch" />
  }

  <!--  -->
  @if(fetchStatus().isLoading && data().Matches.length === 0) {
  <app-skeleton-match-past />
  }

  <!--  -->
  @if(data().Matches.length > 0) {
  <div class="flex flex-col items-center gap-2">
    <div
      class="w-full p-5 mb-3 capitalize bg-red-4 font-roboto-500 text-16 rounded-5 text-grey-1 max-sm:text-13 max-sm:p-3"
    >
      {{ getTextLabel() }}
    </div>

    @for (match of data().Matches; track match.id) {
    <app-past-match-item [match]="match" class="w-full" />
    }

    <!--  -->
    @if(fetchStatus().isLoading ) {
    <app-skeleton-match-past class="w-full" [onlyItem]="true" />
    }

    <!--  -->
    @if(!fetchStatus().isLoading && data().TotalPages && data().TotalPages! > 1
    && data().TotalPages! > page()) {
    <button
      class="flex items-center gap-1 p-3 text-red-2 font-roboto-500"
      (click)="handlePagination()"
    >
      <span>{{ "ShowMoreMatches" | translate }}</span>
      <img alt="logo" [src]="urlIMG + 'icons/add.svg'" />
    </button>
    }
  </div>
  }
</div>
